module.exports = __webpack_public_path__ + "static/media/click-low-01.8eba1c3e.mp3";